import MyinfoContainer from '../../containers/auth/MyinfoContainer'

const MyinfoPage = () => {
  return <MyinfoContainer />
}

export default MyinfoPage
